import { retryFetch } from './RetryHelper';
import { debug } from 'src/logger';
import initialMetricsPublisher from "src/metrics";

export interface GetA2ZQuoteStatusRequest {
    a2zAssociationId: String
}

export interface GetA2ZQuoteStatusResponse {
    signed: boolean
}

export const getA2ZQuoteStatus =
    async (params: GetA2ZQuoteStatusRequest): Promise<GetA2ZQuoteStatusResponse> => {
        try {
            return await retryFetch(async () => {
                debug('Making GetA2ZQuoteStatus Request:', params);
                const response = await fetch('/getstarted/api/getA2ZQuoteStatus', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(params)
                });
                if (!response.ok) {
                    if (response.status === 429) {
                        const actionMetricsPublisher = initialMetricsPublisher.newChildActionPublisherForMethod('GetA2ZQuoteStatusCall');
                        actionMetricsPublisher.publishCounterMonitor('MonsServiceRateLimitCount', 1);
                    }
                    throw new Error('Encountered exception when calling GetA2ZQuoteStatus')
                }

                const data = await response.json();
                debug('Received GetA2ZQuoteStatus Response:', data);

                return {
                    signed: data.signed
                };
            });
        } catch (error) {
            console.error('Encountered exception calling GetA2ZQuoteStatus');
            return { signed: false };
        }
}
